import React from 'react';


export const disableCorePrefetching = () => true;
